<template>
<div>
   <vs-row vs-type="flex" vs-justify="space-between">
      <vs-col vs-justify="flex-start" vs-lg="5" class="m-3" >
        <form-label>{{$t('MRMR.Statement.CompareWithTitle')}}</form-label>
        <v-select
          label="name"
          :reduce="item => item.id"
          :options="previousStatementList"
          v-model="comparisonStatementId"
          class="w-full">
          <template #option="{ name, isPrevious }">
            <div class="d-center">
              <span v-if="isPrevious" style="color:blue">{{ name }}</span>
              <span v-else>{{ name  }}</span>
            </div>
          </template>
        </v-select>       
      </vs-col>
      <vs-col v-if="!readOnly" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="2"  class="m-3" >
        <feather-icon icon="PlusCircleIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="addNewData" v-b-tooltip.hover :title="$t('AddNew')" />
        <feather-icon icon="TrashIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="openDeleteConfirm" v-b-tooltip.hover :title="$t('Delete')" />
      </vs-col>
    </vs-row>
    <ag-grid-vue
      ref="agGridTable"
      :components="components"
      :gridOptions="gridOptions"
      :context="context"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="entryList"
      :rowClassRules="rowClassRules"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :pagination="false"
      :suppressPaginationPanel="true"
      :enableCellChangeFlash="false"
      :enableRtl="$vs.rtl"></ag-grid-vue>
</div>

</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";

import Vue from "vue";
import vSelect from 'vue-select';

import EntryActionsCellRenderer from './EntryActionsCellRenderer.vue'
import EntryDiffValueCellRenderer from './EntryDiffValueCellRenderer.vue'
import ElementEnum from '@/app/shared/ElementEnum.js';
import {
  // FormLabel,
  FormLabel
} from "../../../../shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    EntryActionsCellRenderer,
    EntryDiffValueCellRenderer,
    vSelect,
    FormLabel
  },
  props: {
    entries: {
      type: Array,
      default: () => {}
    },
    previousStatements : {
      type: Array
    },
    periodId : {
      type: Number
    },
    readOnly : {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedProjectId: null,
      isMounted: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true
      },
      gridApi: null,
      comparisonStatementId : null,
      gridOptions: {
        getRowNodeId: (data) => {
          return data.id;
        }
      },
      context: { componentParent: this }, 
      rowClassRules: {
        'entry-isNew': 'data.isNew',
        'entry-isDeleted': 'data.isDeleted'
      },
      cellClassRules: {
        'cell-isDeleted': 'data.isDeleted'
      },
      columnDefs: [
        {
          headerName: 'Actions',
          field: 'id',
          width: 225,
          editable: false,
          sortable: false,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: Vue.extend(EntryActionsCellRenderer)
        },
        {
          headerName: this.$t('MRMR.Entry.Area'),
          field: "area",
          width: 125,
          filter:'agTextColumnFilter',
          cellStyle : this.deletedCellStyle
        },
        {
          headerName: this.$t('MRMR.Entry.MiningType'),
          field: "miningType",
          width: 250,
          valueGetter: (params) => {
            return this.$t("MRMR.MiningType." + params.data.miningType);
          },
          cellStyle : this.deletedCellStyle
        },
        {
          headerName: this.$t('MRMR.Entry.ResourceType'),
          field: "resourceType",
          width: 200,
          valueGetter: (params) => {
            return this.$t("MRMR.ResourceType." + params.data.resourceType);
          },
          comparator:  (valueA, valueB, nodeA, nodeB) => {
            return nodeA.data.resourceType === nodeB.data.resourceType ? 0 : (nodeA.data.resourceType > nodeB.data.resourceType ? 1 : -1);
          },
          cellStyle : this.deletedCellStyle
        },
        {
          headerName: this.$t('MRMR.Entry.Tonnage'),
          field: "tonnage",
          width: 200,
          filter:'agNumberColumnFilter',
          valueGetter: (params) => {
            return this.getTonnage(params)
          },
          comparator:  (valueA, valueB) => {
            return this.compareActuals(valueA, valueB);
          },
          cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
          cellStyle : this.deletedCellStyle
        },
        {
          headerName: this.$t('MRMR.Entry.Elements'),
          field: "elements",
          width: 200,
          valueGetter: (params) => {
            if (params.data.elements === null || params.data.elements.length === 0) {
              return this.$t("MRMR.Entry.AllElements");
            }
            return params.data.elements.map(e => this.$t("Element." + e)).join(", ");
          },
          cellStyle : this.deletedCellStyle
        },
        {
          headerName: this.$t('Element.' + ElementEnum.Gold),
          children: [
            { 
              headerName: this.getGradeHeader(ElementEnum.Gold),
              field: "grades",
              width: 100,
              valueGetter: (params) => {
                return this.getGrade(params, ElementEnum.Gold)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }, 
            { 
              headerName:  "Oz",
              field: "grades",
              width: 150,
              valueGetter: (params) => {
                return this.getUnits(params, ElementEnum.Gold)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }
          ]
        },
        {
          headerName: this.$t('Element.' + ElementEnum.Silver),
          children: [
            { 
              headerName: this.getGradeHeader(ElementEnum.Silver),
              field: "grades",
              width: 100,
              valueGetter: (params) => {
                return this.getGrade(params, ElementEnum.Silver)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }, 
            { 
              headerName:  "Oz",
              field: "grades",
              width: 150,
              valueGetter: (params) => {
                return this.getUnits(params, ElementEnum.Silver)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }
          ]
        },
        {
          headerName: this.$t('Element.' + ElementEnum.Copper),
          children: [
            { 
              headerName: this.getGradeHeader(ElementEnum.Copper),
              field: "grades",
              width: 100,
              valueGetter: (params) => {
                return this.getGrade(params, ElementEnum.Copper)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }, 
            { 
              headerName:  "Kg",
              field: "grades",
              width: 150,
              valueGetter: (params) => {
                return this.getUnits(params, ElementEnum.Copper)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }
          ]
        },
        {
          headerName: this.$t('Element.' + ElementEnum.Lead),
          children: [
            { 
              headerName: this.getGradeHeader(ElementEnum.Lead),
              field: "grades",
              width: 100,
              valueGetter: (params) => {
                return this.getGrade(params, ElementEnum.Lead)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }, 
            { 
              headerName:  "Kg",
              field: "grades",
              width: 150,
              valueGetter: (params) => {
                return this.getUnits(params, ElementEnum.Lead)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }
          ]
        },
        {
          headerName: this.$t('Element.' + ElementEnum.Zinc),
          children: [
            { 
              headerName: this.getGradeHeader(ElementEnum.Zinc),
              field: "grades",
              width: 100,
              valueGetter: (params) => {
                return this.getGrade(params, ElementEnum.Zinc)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }, 
            { 
              headerName:  "Kg",
              field: "grades",
              width: 150,
              valueGetter: (params) => {
                return this.getUnits(params, ElementEnum.Zinc)
              },
              comparator:  (valueA, valueB) => {
                return this.compareActuals(valueA, valueB);
              },
              cellRendererFramework: Vue.extend(EntryDiffValueCellRenderer),
              cellStyle : this.deletedCellStyle
            }
          ]
        }
      ],
      components: {
        EntryActionsCellRenderer,
        EntryDiffValueCellRenderer
      }
    };
  },
  watch: {
    comparisonStatementId(val) {
      if (val) {
        const params = {
          force: true,
          suppressFlash: true
        };
        this.gridApi.refreshCells(params);
      }
    }
  },

  computed: {
    previousStatementList() {
      const previousStatememt = this.$props.previousStatements.find(o => o.mrmrStatementPeriodId !== this.$props.periodId)

      const values = this.$props.previousStatements.map(obj => {
        return {
          id: obj.id,
          name : obj.period.name + ' - v' + obj.version,
          isPrevious: previousStatememt !== undefined ? obj.id === previousStatememt.id : false
        }
      });

      return values;
    },
    entryList() {

      // clone the lists
      const actualEntries =  this.$props.entries.map((x) => x);
      const comparisonEntries = this.comparisonStatements.map((x) => x);
      
      // find new entries
      actualEntries.forEach(actualEntry => {
        // find new entries
        const existing = comparisonEntries.find(entry => actualEntry.area === entry.area 
          && actualEntry.resourceType === entry.resourceType 
          && actualEntry.miningType === entry.miningType);

        actualEntry.isNew = existing === undefined;
        actualEntry.isDeleted = false;
        
      });

      // find missing entries
      comparisonEntries.forEach(entry => {
        // find new entries
        const existing = actualEntries.find(actualEntry => actualEntry.area === entry.area 
          && actualEntry.resourceType === entry.resourceType 
          && actualEntry.miningType === entry.miningType);

        if (existing === undefined) {
          entry.isNew = false;
          entry.isDeleted = true;
          actualEntries.push(entry);
        }
      });

      return actualEntries;

    },
    comparisonStatements() {
      const statement = this.$props.previousStatements.find(o => o.id === this.comparisonStatementId);
      if (statement !== null && statement !== undefined) {
        return statement.entries;
      }
      
      return [];
    }
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
  
    if (this.$props.readOnly) {
      // remove the action colum if read only
      this.columnDefs.splice(0, 1);
    }

    if (this.$props.previousStatements !== null && this.$props.previousStatements.length > 0) {      
      const previousStatememt = this.$props.previousStatements.find(o => o.mrmrStatementPeriodId !== this.$props.periodId)
      if (previousStatememt !== undefined) {
        this.comparisonStatementId = previousStatememt.id;
      } else
      {
        this.comparisonStatementId = this.$props.previousStatements[0].id;
      }
     
    }
  },

  methods: {
    deletedCellStyle(params) {
      if (params.data.isDeleted) {
        //mark police cells as red
        return {'text-decoration': 'line-through !important'};
      }

      return null;
    },
    getGradeHeader(element) {
      if (element === ElementEnum.Gold || element === ElementEnum.Silver)
        return "g/t";
      else
        return "%";
    },
    editData(entry) {
      this.$emit("onEditEntry", entry);
    },

    getTonnage(params) {
      if (this.comparisonStatements !== null) {
        const previousEntry = this.comparisonStatements.find(e => e.area === params.data.area && e.resourceType === params.data.resourceType && e.miningType === params.data.miningType);
        if (previousEntry !== null && previousEntry !== undefined) {
          return {
            actualValue : params.data.tonnage,
            previousValue : previousEntry.tonnage,
            isTonnage : true
          };
        } else {
          return {
            actualValue :  params.data.tonnage,
            previousValue : null,
            isTonnage : true
          };
        }
      }
      else {
        return {
          actualValue :  params.data.tonnage,
          previousValue : null,
          isTonnage : true
        };
      }
    },
    getGrade(params, elementId) {
      if (params.data.grades !== null) {
        const element = params.data.grades.find(r => r.element === elementId)
        if (element) {
          if (this.comparisonStatements !== null) {
            const previousEntry = this.comparisonStatements.find(e => e.area === params.data.area && e.resourceType === params.data.resourceType && e.miningType === params.data.miningType);
            if (previousEntry !== null && previousEntry !== undefined && previousEntry.grades !== null) {
              const previousElement = previousEntry.grades.find(r => r.element === elementId);
              if (previousElement !== null && previousElement !== undefined) {
                return {
                  actualValue :  element.grade,
                  previousValue : previousElement.grade,
                  isGrade : true
                };
              } else {
                return {
                  actualValue :  element.grade,
                  previousValue : null,
                  isGrade : true
                };
              }
            } else {
              return {
                actualValue :  element.grade,
                previousValue : null,
                isGrade : true
              };
            }
          }
          else {
            return {
              actualValue :  element.grade,
              previousValue : null,
              isGrade : true
            };
          }
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },

    getUnits(params, elementId) {
      if (params.data.grades !== null) {
        const element = params.data.grades.find(r => r.element === elementId)
        if (element) {
          if (this.comparisonStatements !== null) {
            const previousEntry = this.comparisonStatements.find(e => e.area === params.data.area && e.resourceType === params.data.resourceType && e.miningType === params.data.miningType);
            if (previousEntry !== null && previousEntry !== undefined && previousEntry.grades !== null) {
              const previousElement = previousEntry.grades.find(r => r.element === elementId);
              if (previousElement !== null && previousElement !== undefined) {
                return {
                  actualValue :  this.calculateUnits(element.grade, params.data.tonnage, elementId),
                  previousValue : this.calculateUnits(previousElement.grade, previousEntry.tonnage, elementId),
                  isUnit : true
                };
              } else {
                return {
                  actualValue :  this.calculateUnits(element.grade, params.data.tonnage, elementId),
                  previousValue : null,
                  isUnit : true
                };
              }
            } else {
              return {
                actualValue :  this.calculateUnits(element.grade, params.data.tonnage, elementId),
                previousValue : null,
                isUnit : true
              };
            }
          }
          else {
            return {
              actualValue :  this.calculateUnits(element.grade, params.data.tonnage, elementId),
              previousValue : null,
              isUnit : true
            };
          }
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    calculateUnits(grade, tonnage, element)
    {
      if (element === ElementEnum.Gold || element === ElementEnum.Silver)
      {
        return grade * tonnage / 31.1035
      } else {
        return grade * tonnage * 10;
      }
      
    },
    compareActuals(valueA, valueB) {
      if (valueA.actualValue === valueB.actualValue) {
        return 0;
      } 
      else {
        return (valueA.actualValue > valueB.actualValue) ? 1 : -1;
      }
    },
  
    deleteData(index) {
      this.$emit("onDeleteEntry", index);
    },
    restoreData(index) {
      const entry = this.entryList[index];
      this.$emit("onRestoreEntry", entry);
    },

    openDeleteConfirm() {
      const rows = this.gridApi.getSelectedRows();
      if (rows.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: this.$t("Delete"),
          text: this.$t('MRMR.Entry.NoEntrySelected')
        })
      }
      else {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: this.$t("Delete"),
          text: this.$t('MRMR.Entry.ConfirmDeleteMultiple'),
          accept: this.deleteMany
        });
      }
    },
    addNewData() {
      this.$emit("onAddEntry");
    },
    deleteMany() {
      const rows = this.gridApi.getSelectedNodes();
      const indexes = rows.map(r => r.rowIndex)
      this.$emit("onDeleteEntries", indexes);
     
    }
  }
};
</script>
<style lang="scss">
.entry-isNew {
  border-width: 1 !important;
  border-style: solid !important;
  border-color: #2874A6 !important;
}

.entry-isDeleted {
  border-width: 1 !important;
  border-style: solid !important;
  border-color:  #E57373 !important;
  text-decoration: line-through !important;
}

.cell-isDeleted {
  text-decoration: line-through !important;
}


</style>

